export default {
  "OD": "右眼",
  "OS": "左眼",
  "Both": "双眼",
  "male": '男',
  "female": '女',
  "yes": "是，继续原治疗方案",
  "exit": "否，退出治疗",
  "update": "是，但改变治疗方案",
  "logout": "退出登录",
  "login": "立即登录",
  "title": "近视常规治疗无效儿童使用红光治疗的真实世界注册研究",
  "institution_id": "机构编号",
  "study_id": "StudyID",
  "name": "姓名",
  "ethnicity": "种族",
  "birthday": "出生日期",
  "sex": "性别",
  "password": '密码',
  "treatment_history": "治疗史",
  "duration_of_treatment": "治疗时长",
  "refractive_error_progression": "近一年的度数增长",
  "axial_elongation": "近一年的眼轴增长",
  "initial_selection_results": "入选结果",
  "first_examination_results": "首次检查结果",
  "date_of_visit": "检查日期",
  "axial_length": "眼轴",
  "subjective_refraction": "主观验光度数",
  "spherical_diopter": "球镜度数",
  "cylindrical_diopter": "柱镜度数",
  "axis_degree": "轴位",
  "cycloplegic_refraction": "散瞳验光度数",
  "best_corrected_visual_acuity": "最佳矫正视力(小数视力)",
  "visual_acuity_notes": "视力检查备注",
  "adverse_reactions": "不良反应",
  "continue_treatment": "是否继续治疗",
  "reason_not_to_continue": "不继续治疗原因",
  "new_treatment_plan": "新的治疗方案",
  "oct_report_conclusion": "OCT报告结论",
  "research_team_introduction": "研究团队介绍",
  "principal_investigator": "研究主要负责人",
  "participant_login": "受试者登录",
  "researcher_login": "研究员登录",
  "contact_us": "联系我们",
  "project_email": "项目邮箱",
  "contact_person": "联系人",
  "inquiries": "如果您有任何问题，您可以现在或之后向我们的工作人员提问，或联系陈燕先博士（电话：852-27666111/电邮：yan-xian.chen@polyu.edu.hk）或赵紫薇博士（电话：852-61548412 / 电邮：zavia.zhao@connect.polyu.edu.hk）。",
  "complaints": "如果您对本研究的进行有任何不满或投诉，您可以电邮联系理工大学机构审查委员会秘书（institutional.review.board@polyu.edu.hk），请清楚说明本研究的负责人和部门以及参考编号。",
  "institutional_review_board": "理工大学机构审查委员会秘书",
  "yjtd_text": "研究主要负责人何明光教授现任香港理工大学杰出创科学人计划讲席教授，中山大学中山眼科中心客座教授。曾任中山大学中山眼科中心教授二级教授，墨尔本大学眼科学教授。国家杰出青年基金获得者、国家“万人计划”领军人才、广东特支计划杰出人才（“南粤百杰”），兼任亚太眼科学会常务理事，亚太近视学会创会副秘书长与理事，《英国眼科杂志》副主编，2023年入选世界最具影响力眼科人物100強。其研究成果多次以论著方式发表在Lancet、JAMA等国际权威期刊。研究团队在近视防控领域和全球合作方面具有丰富经验，成果在学术界获得广泛认可。研究团队致力于通过国际合作，共同应对全球范围内近视的高发趋势，为人们提供更好的视力健康保护和服务。",
  "yjxx_foot": '本项目已通过香港理工大学伦理审批（编号HSEARS20240113001）。',
  "yjxx": "研究信息",
  "yjtd": "研究团队",
  "year": "年",
  "month": "月",
  "D_per_year": "D/年",
  "mm_per_year": "mm/年",
  "cylindrical_diopter": "DC",
  "axis_degree": "°",
  "mm": "mm",
  'atropine': '阿托品滴眼液',
  'ok': 'OK镜',
  'dims': '周边离焦眼镜',
  'untreated': "未治疗",
  'others': '其他',
  'asian': '亚洲人',
  'black_african':'黑人/非洲人',
  'caucasian_white':'高加案人种（白种人）',
  'hhspanic_Latino': '西班牙裔或拉丁美洲人',
  'middle_eastern':'中东人',
  'native_american':'美洲原住民',
  'pacific_islander':'太平洋岛民',
  'mixed_race': '混血种族',
  'other':'其他',
  'orthokeratology_RLRL': 'OK镜+红光治疗',
  'DIMS_RLRL': '周边离焦眼镜+红光治疗',
  'DIMS_RLRL_therapy': "周边离焦眼镜+红光治疗",
  'orthokeratology_RLRL_therapy': 'OK镜+红光治疗',
  'Stop_conventional_treatments_and_switch_to_RLRL_therapy': '停止其他疗法，转换为红光治疗',
  'other_RLRL_therapy': '红光治疗+其他',
  'RLRL': '仅红光治疗',
  'unsuitable': '不适用',
  'none': '无',
  'worsened_visual_acuity': '视力下降',
  'central_scotoma': '中心暗点',
  'prolonged_afterimage_5_minutes': '后像延长>5分钟',
  'choose_an_alternative_treatment_plan': "选择其他治疗",
  'patient_goes_to_another_clinic': '受试者更换诊所',
  'patient_declines': '受试者拒绝',
  'contraindications': '发现禁忌症',
  'follow_up_text': '第{n}次随访结果',
  'date_of_rlrltherapy_commencement': "红光治疗开始日期",
  "yjxxdl": "研究信息告知（中文版）下载",
  "yjxxdl_en": "研究信息告知（英文版）下载",
  "inform": "知情同意书签字页下载",
  "edc_text": "红光真实世界研究 EDC 网页录入说明",
  "edc_video": "红光真实世界研究 EDC 网页录入说明(视频版)",
  "edc_en_text": "红光真实世界研究 EDC 网页录入说明_英文版",
  "edc_en_video": "红光真实世界研究 EDC 网页录入说明_英文版(视频版)",
  'whatchOnline': '在线播放',
  'Download': '下载'
}